// @ts-ignore
import { jStat } from 'jstat';

/**
 * Defaults returns the z* for a 95% Confidence level
 * alpha = 1 - (confidenceLevel / 100): 1 - (95/100) = 0.05
 * criticalProbability (p*) = 1 - alpha/2: 1 - 0.05/2 = 0.975
 * We divide by 2 because we are calculating a two-sided Confidence Interval
 * (p*) reflects the probability that the interval we produce will capture the true difference in proportions (i.e. lift)
 *
 *
 * @param {number} confidenceLevel - eg. 95 for 95% confidence level, 90 for 90% confidence level
 * @return {number} z* reflects the critical value under a normal curve where the cumulative probability is equal to p*
 */
const NINETY_FIVE_PERCENT_CONFIDENCE_LEVEL = 95;

export const getZScore = (confidenceLevel: number = NINETY_FIVE_PERCENT_CONFIDENCE_LEVEL) => {
  const confLevel = confidenceLevel;
  const alpha = 1 - confLevel / 100;
  const criticalProbability = 1 - alpha / 2;
  return jStat.normal.inv(criticalProbability, 0, 1);
};
